const ClockIcon = () => {
  return (
    <svg
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3307_6250)">
        <path
          d="M3.75 9.75C3.75 10.4394 3.8858 11.1221 4.14963 11.7591C4.41347 12.396 4.80018 12.9748 5.28769 13.4623C5.7752 13.9498 6.35395 14.3365 6.99091 14.6004C7.62787 14.8642 8.31056 15 9 15C9.68944 15 10.3721 14.8642 11.0091 14.6004C11.646 14.3365 12.2248 13.9498 12.7123 13.4623C13.1998 12.9748 13.5865 12.396 13.8504 11.7591C14.1142 11.1221 14.25 10.4394 14.25 9.75C14.25 9.06056 14.1142 8.37787 13.8504 7.74091C13.5865 7.10395 13.1998 6.5252 12.7123 6.03769C12.2248 5.55018 11.646 5.16347 11.0091 4.89963C10.3721 4.6358 9.68944 4.5 9 4.5C8.31056 4.5 7.62787 4.6358 6.99091 4.89963C6.35395 5.16347 5.7752 5.55018 5.28769 6.03769C4.80018 6.5252 4.41347 7.10395 4.14963 7.74091C3.8858 8.37787 3.75 9.06056 3.75 9.75Z"
          stroke="#9D9D9D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 7.5V9.75H10.5"
          stroke="#9D9D9D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 3L3.1875 4.5"
          stroke="#9D9D9D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.75 3L14.8125 4.5"
          stroke="#9D9D9D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3307_6250">
          <rect fill="white" height="18" width="18" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ClockIcon;
